import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { PrivacyPolicyService } from '@app/core/privacy-policy/services/privacy-policy.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IUserPrivacySettings } from '@app/core/user/store/reducers/user.reducers';

@Component({
  selector: 'vc-privacy-policy-settings',
  templateUrl: './privacy-policy-settings.component.html',
  styleUrls: ['./privacy-policy-settings.component.scss']
})
export class PrivacyPolicySettingsComponent implements OnInit {
  @ViewChild('acceptCookies', { read: ElementRef, static: false })
  acceptCookies: ElementRef;
  @ViewChild('acceptRetargeting', { read: ElementRef, static: false })
  acceptRetargeting: ElementRef;
  @ViewChild('acceptAnalytics', { read: ElementRef, static: false })
  acceptAnalytics: ElementRef;

  constructor(
    private privacyPolicyService: PrivacyPolicyService,
    private dialogRef: MatDialogRef<PrivacyPolicySettingsComponent>,
    @Inject(MAT_DIALOG_DATA) public initialState: IUserPrivacySettings
  ) {}

  ngOnInit() {}

  setUserChoices(e) {
    e.preventDefault();
    const settings: IUserPrivacySettings = {
      showBanner: false,
      acceptCookies: this.acceptCookies.nativeElement.checked ? 'selected_true' : 'selected_false',
      acceptRetargeting: this.acceptRetargeting.nativeElement.checked ? 'selected_true' : 'selected_false',
      acceptAnalytics: this.acceptAnalytics.nativeElement.checked ? 'selected_true' : 'selected_false'
    };

    this.privacyPolicyService.updateSettings(settings);
    this.dialogRef.close(settings);
  }
}
